import request from './request'

/**
 * 分页查询方案列表
 * @param {object} data - 查询参数
 * @param {number} [data.customerId] - 客户ID
 * @param {number} [data.status] - 状态：0草稿 1执行中 2已完成 3已取消 4待审核
 * @param {string} [data.keyword] - 关键字（方案编号/名称）
 * @param {number} [data.page=1] - 页码，从1开始
 * @param {number} [data.size=20] - 每页大小
 */
export function getPlanPage(data) {
  return request.post('/plan/page', data)
}

/**
 * 获取方案详情
 * @param {number} id - 方案ID
 */
export function getPlanDetail(id) {
  return request.get(`/plan/${id}`)
}

/**
 * 保存方案（新建）
 * @param {object} data - 方案保存请求
 * @param {object} data.plan - 方案信息
 * @param {number} data.plan.customerId - 客户ID
 * @param {string} data.plan.name - 方案名称
 * @param {number} [data.plan.status] - 状态
 * @param {number} [data.plan.discount] - 优惠金额
 * @param {number} [data.plan.payableAmount] - 应付金额
 * @param {string} [data.plan.remark] - 备注
 * @param {number} [data.plan.isDraft] - 是否草稿：1草稿 0正式
 * @param {Array} [data.orders] - 订单列表
 * @param {boolean} [data.asDraft=true] - 是否作为草稿保存，默认true
 */
export function savePlan(data) {
  return request.post('/plan/save', data)
}

/**
 * 更新方案
 * @param {object} data - 方案保存请求
 */
export function updatePlan(data) {
  return request.put('/plan', data)
}

/**
 * 删除方案
 * @param {number} id - 方案ID
 */
export function deletePlan(id) {
  return request.delete(`/plan/${id}`)
}

/**
 * 取消方案
 * @param {number} id - 方案ID
 * @description 只能取消执行中的方案，取消后删除方案下的订单和账单
 */
export function cancelPlan(id) {
  return request.put(`/plan/${id}/cancel`)
}

/**
 * 切换方案提醒开关
 * @param {number} id - 提醒配置ID
 * @param {boolean} enabled - 是否启用
 */
export function togglePlanReminderStatus(id, enabled) {
  return request.put(`/plan/reminders/${id}/status`, null, {
    params: { enabled }
  })
}

/**
 * 切换方案账单提醒开关
 * @param {number} planId - 方案ID
 * @param {boolean} enabled - 是否启用
 */
export function toggleBillingReminderStatus(planId, enabled) {
  return request.put(`/plan/${planId}/billing-reminder/status`, null, {
    params: { enabled }
  })
}

/**
 * 切换订单续约提醒开关
 * @param {number} orderId - 订单ID
 * @param {boolean} enabled - 是否启用
 */
export function toggleOrderRenewalReminderStatus(orderId, enabled) {
  return request.put(`/plan/orders/${orderId}/renewal-reminder/status`, null, {
    params: { enabled }
  })
}

/**
 * 删除方案提醒项
 * @param {number} id - 提醒配置ID
 */
export function deletePlanReminder(id) {
  return request.delete(`/plan/reminders/${id}`)
}

/**
 * 删除方案账单提醒
 * @param {number} planId - 方案ID
 */
export function deleteBillingReminder(planId) {
  return request.delete(`/plan/${planId}/billing-reminder`)
}

/**
 * 删除订单续约提醒
 * @param {number} orderId - 订单ID
 */
export function deleteOrderRenewalReminder(orderId) {
  return request.delete(`/plan/orders/${orderId}/renewal-reminder`)
}

/**
 * 切换订单服务提醒开关
 * @param {number} id - 订单服务提醒ID
 * @param {boolean} enabled - 是否启用
 */
export function toggleOrderServiceReminderStatus(id, enabled) {
  return request.put(`/plan/service-reminders/${id}/status`, null, {
    params: { enabled }
  })
}

/**
 * 删除订单服务提醒
 * @param {number} id - 订单服务提醒ID
 */
export function deleteOrderServiceReminder(id) {
  return request.delete(`/plan/service-reminders/${id}`)
}
